import type { HistoryDetail } from '@/services/history/type/history.type';

export const GetTaskIdDTO = Symbol('GetTaskIdDTO');
export interface GetTaskIdDTO {
    fetch: (type: string) => Promise<string>;
}

export const PutHistoryDTO = Symbol('PutHistoryDTO');
export interface PutHistoryDTO<T> {
    fetch: (data: T) => Promise<void>;
}

export const GetHistoryDetailDTO = Symbol('GetHistoryDetailDTO');
export interface GetHistoryDetailDTO {
    fetch: (taskId: string) => Promise<HistoryDetail>;
}
